import Avatar from '@components/v2/ui/Avatar/Avatar';
import ListItemAvatar from '@components/v2/ui/List/ListItemAvatar';
import ListItemText from '@components/v2/ui/List/ListItemText';
import ListSubheader from '@components/v2/ui/List/ListSubheader';
import Menu from '@components/v2/ui/Menu/Menu';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import { HoverSubmenuProps } from '@components/v2/ui/Menu/hooks/useHoverSubmenu.types';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Divider } from '@mui/material';
import React from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { TeamSelectorGroup } from './teamSelector.types';

interface TeamSelectorProps extends HoverSubmenuProps {
  groups: TeamSelectorGroup[];
  onSelect: (id: string) => void;
}

const TeamSelector = ({
  groups,
  anchorEl,
  onClose,
  onSelect,
  onMouseEnter,
  onMouseLeave,
}: TeamSelectorProps) => {
  const { translate } = useTranslation();

  const isEmpty = !groups?.length;

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      transformOrigin={{ horizontal: 'left', vertical: 'bottom' }}
      isHoverSubmenu
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      slotProps={{
        paper: { sx: { maxHeight: 500, maxWidth: 250, minWidth: 160, overflowY: 'auto' } },
      }}
    >
      {isEmpty ? (
        <Box sx={{ px: 2, py: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {translate(LangEnum.GLOBAL_NO_TEAM)}
          </Typography>
        </Box>
      ) : (
        groups.map((group, groupIndex) => (
          <React.Fragment key={group.label}>
            {groupIndex > 0 && <Divider />}
            <ListSubheader>{group.label}</ListSubheader>
            {group.items.map((item) => (
              <MenuItem key={item.id} selected={item.isSelected} onClick={() => onSelect(item.id)}>
                <ListItemAvatar>
                  <Avatar
                    src={item.logoUrl}
                    alt={item.name}
                    fallback="initials"
                    initials={item.initial}
                  />
                </ListItemAvatar>
                <ListItemText primary={item.name} slotProps={{ primary: { noWrap: true } }} />
              </MenuItem>
            ))}
          </React.Fragment>
        ))
      )}
    </Menu>
  );
};

export default TeamSelector;
